import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/cadencias'),
      roles: ['administrator', 'supervisor'],
      component: SettingsContent,
      props: {
        headerTitle: 'CADENCIA_SETTINGS.TITLE',
        icon: 'flash-settings',
        showBackButton: true,
        backUrl: { name: 'settings_applications' },
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'cadencia_settings_index',
          component: Index,
          roles: ['administrator', 'supervisor'],
        },
      ],
    },
  ],
};
